"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _OnlyHeaderLayoutPage = require("./OnlyHeaderLayoutPage");
Object.keys(_OnlyHeaderLayoutPage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OnlyHeaderLayoutPage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OnlyHeaderLayoutPage[key];
    }
  });
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
var _prepareOnlyHeaderLayoutProps = require("./prepareOnlyHeaderLayoutProps");
Object.keys(_prepareOnlyHeaderLayoutProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _prepareOnlyHeaderLayoutProps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _prepareOnlyHeaderLayoutProps[key];
    }
  });
});
var _translations = require("./translations");
Object.keys(_translations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _translations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _translations[key];
    }
  });
});
var _OnlyHeaderLayoutFeature = require("./OnlyHeaderLayoutFeature");
Object.keys(_OnlyHeaderLayoutFeature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OnlyHeaderLayoutFeature[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OnlyHeaderLayoutFeature[key];
    }
  });
});
